export class HrCodeTextValue {

    discriminator: string;
    code: string;

    constructor(discriminator: string, code: string) {
        this.discriminator = discriminator;
        this.code = code;
    }

}
